import CKEditorField from "components/CkEditor/CkEditor";
import { CustomAsyncSelect } from "components/Common/Common";
import SaveRecommendationTemplatePop from "components/Modals/SaveRecommendationTemplate";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useField, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import React, { useEffect, useRef, useState } from "react";
import down_arrow_img from "../../../../Assets/images/down-arro.png"
import { useGetRecommendationTemplatesQuery, useLazyGetRecommendationTemplatesQuery, useLazyGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import threDots_img from "Assets/images/three-dots.png"
import { Accordion, Col, Dropdown, Row } from "react-bootstrap";
import AppInputField from "components/shared/FormComponents/AppInputField";
import TrackerRangeSlider from "components/shared/ReportComponents/TrackerRangeSlider/Index";
import SaveStrategyTemplatePop from "components/Modals/SaveStrategyTemplatePop";
import sliderImageRange from "../../../../Assets/images/sliderImagetoggle.png"
import { toPng } from "html-to-image";
import { SINGLE_ASSESSMENT_PLAN_FIELD } from "helpers/assessment";
import AddAssessmentPop from "../Modals/AddAssessmentPop";
import { cloneDeep, isEmpty } from "lodash";
import { dateFormat } from "helpers/common";
import { MAX_REPORT_ASSESSMENTS, reportDateFormat } from "config/constants";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useCreateGoalMutation, useDeleteGoalMutation, useUpdateGoalMutation } from "store/services/clients/reports-v2/treatmentPlanGoals";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useGetDisciplineAreasQuery, useGetGoalsQuery } from "store/services/utility";
import { useAddAssessmentGoalStrategyMutation } from "store/services/clients/reports-v2/schoolReports";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { components } from "react-select";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { STRATEGY_OPTIONS } from "config/constants";
import StrategiesTemplatesPop from "components/Modals/StrategyTemplatesPop";
import AddAssessmentGoalPop from "../Modals/AddAssessmentGoal";

const QuestionTreatmentPlan = ({ fieldName, question, fieldData, previewMode, clientType, assessmentId, therapist, max, maxRecommendations, assessmentAssignedId, refetchData, dataFetching, ...props }) => {
    const [field, meta] = useField(props.fieldName);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const { setFieldValue, values, touched, errors, setFieldTouched } = useFormikContext();
    const [activeKey, setActiveKey] = useState(0);
    const { show: showStrategyPopup, data: dataStrategyPopup, open: openStrategyPopup, close: closeStrategyPopup } = useModal();
    const { show: showGoalPopup, data: goalPopupData, open: openGoalPopup, close: closeGoalPopup } = useModal();

    const disciplineId = therapist?.therapist_discipline?.id
    const [createGoal, { isLoading: createGoalLoading }] = useCreateGoalMutation();
    const [updateGoal, { isLoading: updateGoalLoading }] = useUpdateGoalMutation()
    const [deleteGoal, { isLoading: deleteGoalLoading }] = useDeleteGoalMutation()



    const [getTemplates, { isFetching }] = useLazyGetStartegyTemplatesQuery();

    const getTemplateOptions = async (search) => {
        try {
            const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
            const templates = data?.records || [];
            return templates?.map(i => ({
                label: i.title,
                value: i,
                // tags: i.StrategyTemplateTagsMapping
                //     ?.map(tag => tag?.strategyTemplateTags?.name)
                //     .filter(Boolean) || []
            }))
        } catch (error) {
            console.log("Error Getting template options", error);
        };
    };

    const handleAddGoal = async (response) => {
        try {
            const data = cloneDeep(response?.data) || [];

            // Build API representation for each incoming goal
            const formattedData = data.map((item) => {
                const apiItem = {
                    id: item?.id,
                    assesment_id: item?.assesment_id,
                    discipline_id: item?.discipline_id,
                    area_id: item?.assesmentGoalStrategyArea?.name
                        ? { value: item?.area_id, label: item?.assesmentGoalStrategyArea?.name }
                        : "",
                    goal_id: item?.assesmentGoalStrategyDetail?.title
                        ? { value: item?.goal_id, label: item?.assesmentGoalStrategyDetail?.title }
                        : "",
                    goal_details: item?.goal_details || "",
                };

                if (item?.AssessmentGoalStrategyData?.length) {
                    apiItem.AssessmentGoalStrategyData = item.AssessmentGoalStrategyData.map((s) => {
                        let attachmentData = [];
                        try {
                            attachmentData = s?.attachmentData ? JSON.parse(s.attachmentData) : [];
                        } catch (e) {
                            // keep as empty array if parse fails
                            attachmentData = [];
                        }
                        return {
                            id: s?.id,
                            goal_strategy_id: s?.goal_strategy_id,
                            type: s?.type,
                            title: s?.type,
                            answers: s?.answers,
                            attachmentData,
                        };
                    });
                } else {
                    apiItem.AssessmentGoalStrategyData = [{ answers: "", attachmentData: [] }];
                }

                return apiItem;
            });

            const existingList = values[fieldName] || [];
            const apiById = new Map(formattedData.map((i) => [i.id, i]));

            // 1) Update existing goals: overwrite fields from API but keep Formik strategies if present
            const updatedExisting = existingList.map((existing) => {
                const apiItem = apiById.get(existing.id);
                if (!apiItem) return existing; // no update available from API

                const strategies =
                    existing.AssessmentGoalStrategyData && existing.AssessmentGoalStrategyData.length
                        ? existing.AssessmentGoalStrategyData
                        : apiItem.AssessmentGoalStrategyData;

                // keep other local properties on `existing` (UI state, temp fields) but overwrite with API values
                return { ...existing, ...apiItem, AssessmentGoalStrategyData: strategies };
            });

            // 2) Add new goals that are in API but not in existingList
            const existingIds = new Set(existingList.map((g) => g.id));
            const toAdd = formattedData.filter((apiItem) => !existingIds.has(apiItem.id));

            const newArray = [...updatedExisting, ...toAdd];

            setFieldValue(fieldName, newArray);
            // optional: setActiveKey(newArray.length - 1)
        } catch (err) {
            console.error("Error adding goal", err);
        }
    };


    const GoalTracking = ({ index, remove, values, setFieldValue, observation, }) => {
        const [selectedArea, setSelectedArea] = useState(null);
        const [selectedGoal, setSelectedGoal] = useState(null);
        const [showDropdown, setShowDropdown] = useState(null);
        const dropdownRef = useRef(null);

        const { data: disciplineAreas, isFetching: areasLoading } = useGetDisciplineAreasQuery(disciplineId, { skip: !disciplineId });
        const disciplineAreaOptions = disciplineAreas?.length > 0 ? disciplineAreas?.map(area => ({ value: area.id, label: area.name })) : [];
        const { data: disciplineAreaGoals, isFetching: goalsLoading } = useGetGoalsQuery({ disciplineId, areaId: values?.treatment_plans?.[index]?.area_id?.value }, { skip: !disciplineId || !values?.treatment_plans?.[index]?.area_id?.value });
        const areaGoalsOptions = disciplineAreaGoals?.length > 0 ? disciplineAreaGoals?.map(goal => ({ value: goal.id, label: goal.title })) : [];

        const toggleDropdown = (e, index) => {
            e.stopPropagation();
            setShowDropdown(showDropdown === index ? null : index);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setShowDropdown(null);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);


        const handleDeleteObservation = async (e, index, remove, goalId) => {
            e.preventDefault()
            e.stopPropagation();
            const isConfirm = await confirmDialogV2({
                title: "DELETE GOAL",
                message: "Are you sure you want to DELETE this goal from your report? All information will be lost.",
            });
            if (!isConfirm) {
                return;
            }
            try {
                await deleteGoal({ goalId }).unwrap()
            } catch (error) {
                console.log('error', error)
            }
            remove(index);
        }


        const handleGoalChange = async (goalId, treatment_plan, area_id) => {
            console.log('treatment_plan', treatment_plan)
            const data = {
                goal_id: goalId,
                area_id: (area_id || area_id == 0) ? area_id : treatment_plan?.area_id?.value,
                discipline_id: disciplineId
            }
            try {
                await updateGoal({ goalId: treatment_plan?.id, data: data, method: "PUT" }).unwrap()
            } catch (error) {
                console.log('error', error)
            }
        }

        return (
            <div style={{ padding: "10px 0px 10px 18px", width: "100%" }}>
                <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center' style={{ borderBottom: "1px solid #315D99" }}>
                    <div>
                        <div className='proxima-regular' style={{ fontWeight: 700, color: "#315D99", fontSize: "14px" }}>
                            <span>Goal </span>{index + 1}
                        </div>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                        <div ref={dropdownRef} className="cstm-dropdownclass">
                            <Dropdown show={showDropdown === index}>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img onClick={(e) => toggleDropdown(e, index)} width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        openGoalPopup(observation);
                                    }}>Edit Goal</Dropdown.Item>
                                    <Dropdown.Item onClick={(e) => { handleDeleteObservation(e, index, remove, observation?.id) }}>Delete Goal</Dropdown.Item>
                                    {/* <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'show'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "show") }}>Add Slider</Dropdown.Item>
                                                                        <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'hidden'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "hidden") }}>Remove Slider</Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>



                        </div>
                    </div>
                </div>
                {/* <div style={{ borderTop: "0.75px solid #315D99", marginLeft: "18px" }}></div> */}
                <div style={{ padding: "14px 0px 14px 3px" }}>
                    <div className="">
                        <Row className="align-items-center">
                            <Col md="2" className="">
                                <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap", color: "#071E3E" }}>AREA:</label>
                            </Col>
                            <Col lg="10">
                                <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{values?.[fieldName]?.[index]?.area_id?.label}</p>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-3">
                        <Row className="align-items-center">
                            <Col md="2" className="">
                                <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap" }}>GOAL:</label>
                            </Col>
                            <Col lg="10">
                                <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{values?.[fieldName]?.[index]?.goal_id?.label}</p>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-3">
                        <Row className="align-items-center">
                            <Col md="2" className="">
                                <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap" }}>DETAIL:</label>
                            </Col>
                            <Col lg="10">
                                <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{values?.[fieldName]?.[index]?.goal_details}</p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            {
                (createGoalLoading || deleteGoalLoading || updateGoalLoading) && <LoadingOverlay />
            }
            <AddAssessmentGoalPop
                showPopup={showGoalPopup}
                closePopup={closeGoalPopup}
                data={goalPopupData}
                assessmentId={assessmentAssignedId}
                disciplineId={disciplineId}
                submitCallback={handleAddGoal}
                clientType={clientType}
            />
            <SaveStrategyTemplatePop
                showPopup={showStrategyPopup}
                closePopup={closeStrategyPopup}
                data={dataStrategyPopup}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <FieldArray name={fieldName}>
                {({ push, remove }) => (
                    <>
                        <div className="goals goals-accordion assessment-report" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "28px" }}>
                            <Accordion onClick={(e) => e.stopPropagation()} activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                {values[fieldName]?.map((observation, index) => (
                                    <React.Fragment key={index}>
                                        <Accordion.Item className="border-0 mb-3" eventKey={index} key={index}>
                                            <div style={{ background: "red" }}>
                                                <Accordion.Header /*style={{ borderBottom: "0.75px solid #000" }}*/>
                                                    <GoalTracking index={index} remove={remove} values={values} setFieldValue={setFieldValue} observation={observation} />
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body>

                                                <Row>
                                                    <FieldArray name={`${fieldName}.${index}.AssessmentGoalStrategyData`}>
                                                        {({ push: strategyPush, remove: strategyRemove }) => (
                                                            <>
                                                                {observation?.AssessmentGoalStrategyData?.map((AssessmentGoalStrategyData, strategyIndex) => (
                                                                    <React.Fragment key={strategyIndex}>
                                                                        <Col lg="12">
                                                                            <div className="mb-4">
                                                                                <StrategyForm
                                                                                    touched={touched}
                                                                                    errors={errors}
                                                                                    setFieldTouched={setFieldTouched}
                                                                                    openModal={open}
                                                                                    remove={strategyRemove}
                                                                                    question={question}
                                                                                    clientType={clientType}
                                                                                    strategyIndex={strategyIndex}
                                                                                    index={index}
                                                                                    setFieldValue={setFieldValue}
                                                                                    values={values}
                                                                                    outerFieldName={fieldName}
                                                                                    assessmentId={assessmentId}
                                                                                    fieldName={`${fieldName}.${index}.AssessmentGoalStrategyData`}
                                                                                    getTemplateOptions={getTemplateOptions}
                                                                                    // openModal={open}
                                                                                    // close={close}
                                                                                    maxStrategy={maxRecommendations}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </React.Fragment>
                                                                ))}
                                                                {
                                                                    console.log('values[fieldName]?.[index]?.AssessmentGoalStrategyData', values[fieldName]?.[index]?.AssessmentGoalStrategyData)
                                                                }
                                                                {
                                                                    maxRecommendations && values[fieldName]?.[index]?.AssessmentGoalStrategyData?.length < 4 &&
                                                                    <Col lg="12">
                                                                        <div style={{ borderTop: "0.75px solid #315D99", paddingTop: "13px" }} className="d-flex mt-2 align-items-center gap-3">
                                                                            <button
                                                                                className="blue-discharge-screen-btn mt-0"
                                                                                type="button"
                                                                                disabled={createGoalLoading || deleteGoalLoading || updateGoalLoading}
                                                                                onClick={() => strategyPush({
                                                                                    answers: "",
                                                                                    attachmentData: [],
                                                                                })}
                                                                            >
                                                                                Add a Strategy
                                                                            </button>
                                                                            <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 4 per treatment.</p>
                                                                        </div>
                                                                        {
                                                                            touched.treatment_plans?.[index]?.AssessmentGoalStrategyData && errors.treatment_plans?.[index]?.AssessmentGoalStrategyData && typeof (errors.treatment_plans?.[index]?.AssessmentGoalStrategyData) == "string" ? (
                                                                                <div className="text-danger mt-3">{errors.treatment_plans?.[index]?.AssessmentGoalStrategyData}</div>
                                                                            ) : null
                                                                        }
                                                                    </Col>
                                                                }
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </React.Fragment>
                                ))}
                            </Accordion>
                        </div>
                        <div className="d-flex mt-2 align-items-center gap-3">
                            {
                                (max && values[fieldName]?.length < max) &&
                                <button
                                    type="button"
                                    className="blue-discharge-screen-btn mt-0"
                                    disabled={createGoalLoading || deleteGoalLoading || updateGoalLoading || dataFetching}
                                    onClick={() =>
                                        // push({
                                        //     tracker_percentage: 0,
                                        //     notes: "",
                                        //     AssessmentGoalStrategyData: [],
                                        //     show_tracker: "show"
                                        // })
                                        openGoalPopup()
                                    }
                                >
                                    Add a Goal
                                </button>
                            }
                            <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 8 per plan.</p>
                        </div>
                    </>
                )}
            </FieldArray>
        </div>
    );
};

const StrategyForm = ({ index, strategyIndex, setFieldValue, values, assessmentId, clientType, fieldName, outerFieldName, getTemplateOptions, remove, question, maxStrategy, touched, errors, setFieldTouched }) => {
    const { show, data, open, close } = useModal();
    const { show: showTemplates, data: templatesData, open: templatesOpen, close: templatesClose } = useModal();
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleTemplateSelect = (selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}.${strategyIndex}.answers`, selected?.value?.answers || "");
        setFieldValue(`${fieldName}.${strategyIndex}.attachmentData`, values?.[fieldName]?.[strategyIndex]?.attachmentData || []);
        setFieldValue(`${fieldName}.${strategyIndex}.template_id`, selected?.value?.id);
    }

    const handleDeleteStrategy = async (e, stratIndex, remove) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE STRATEGY",
            message: "Are you sure you want to DELETE this from your consultation?",
        });
        if (!isConfirm) {
            return;
        }
        remove(stratIndex);
        setFieldTouched(fieldName, true)
    }

    const Option = (props) => {
        const { data, isSelected } = props;
        return (
            <components.Option {...props}>
                <div>
                    <div
                        style={{
                            // fontWeight: isSelected ? "bold" : "normal",
                            color: isSelected
                                ? "#fff"
                                : "#212529"
                        }}
                    >
                        {data.label}
                    </div>
                    {data.tags?.length > 0 && (
                        <div className="mt-1 d-flex flex-wrap gap-1">
                            {data.tags.map((tag, idx) => (
                                <div
                                    key={idx}
                                    className="rounded-pill"
                                    style={{
                                        pointerEvents: "none",
                                        fontWeight: "normal",
                                        backgroundColor: "#e8f5fe",
                                        color: "#007bff",
                                        border: "1px solid #007bff",
                                        padding: "1px 5px",
                                        fontSize: "12px"
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </components.Option>
        );
    };

    useEffect(() => {
        if (values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.template_id) {
            setSelectedTemplate({ value: values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.template_id, label: values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.title })
        }
    }, [data])

    return (
        <>
            <SaveStrategyTemplatePop
                mainSetFieldValue={setFieldValue}
                outerFieldName={outerFieldName}
                index={index}
                strategyIndex={strategyIndex}
                showPopup={show}
                closePopup={close}
                data={data}
                currentStrategyFieldName={'AssessmentGoalStrategyData'}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <StrategiesTemplatesPop
                mainSetFieldValue={setFieldValue}
                setSelectedTemplate={setSelectedTemplate}
                outerFieldName={outerFieldName}
                index={index}
                currentStrategyFieldName={'AssessmentGoalStrategyData'}
                strategyIndex={strategyIndex}
                showPopup={showTemplates}
                closePopup={templatesClose}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <Row>
                <Col style={{ borderBottom: "0.75px solid #000" }} className="px-0" lg="12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 class="m-0 proxima themeBlue fw-bold text-uppercase" style={{ fontSize: "12px" }}>STRATEGY {strategyIndex + 1}</h6>
                        <div className="cstm-dropdownclass">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => handleDeleteStrategy(e, strategyIndex, remove)}>Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Col>
                <Col lg="4" className="px-0" style={{ margin: "12px 0" }}>
                    <p style={{ fontStyle: "italic", color: "#071E3E" }}>{question.template}</p>
                </Col>
                <Col lg="8" style={{ margin: "12px 0" }}>
                    {
                        values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.answers || values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.strategyRadio == "newStrategy" ?
                            <>
                                {
                                    values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.template_id &&
                                    <div className=" justify-content-between gap-3 align-items-center" style={{ borderBottom: "0.75px solid #000000", padding: "0px 0" }}>
                                        <div className="w-100">
                                            <h6 class=" proxima themeBlue" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>Strategy Template</h6>
                                            <CustomAsyncSelect
                                                cstmOption={Option}
                                                placeholder={"(no template selected)"}
                                                loadOptions={getTemplateOptions}
                                                onChange={handleTemplateSelect}
                                                value={selectedTemplate}
                                                defaultOptions={true}
                                            />
                                        </div>
                                        {/* <p>{values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.title}</p> */}

                                    </div>
                                }
                                <div className="ck-editor-wrapper my-2">
                                    <CustomEditor
                                        name={`${fieldName}.${strategyIndex}.answers`}
                                        attachmentName={`${fieldName}.${strategyIndex}.attachmentData`}
                                    />
                                </div>
                                {
                                    !values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.template_id &&
                                    <button
                                        className="blue-discharge-screen-btn mt-0"
                                        type="button"
                                        onClick={() => {
                                            open({
                                                // name: values[fieldName][strategyIndex]?.name,
                                                answers: values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData[strategyIndex]?.answers,
                                            });
                                        }}
                                    >
                                        Save to Templates
                                    </button>
                                }
                            </>
                            :
                            <div className="session-input-radio text-area-report">

                                <div className="radio-inputs">
                                    <AppRadioField
                                        containerClass={"d-flex align-items-center py-1"}
                                        options={STRATEGY_OPTIONS}
                                        name={`${outerFieldName}.${index}.AssessmentGoalStrategyData.${strategyIndex}.strategyRadio`}
                                        labelStyles={{
                                            color: "#071E3E",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Proxima Nova regular",
                                        }}
                                    />
                                    < button
                                        className="blue-discharge-screen-btn mt-3"
                                        type="button"
                                        disabled={!values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.strategyRadio}
                                        onClick={() => {
                                            if (values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.strategyRadio == "new") {
                                                // open({
                                                //     // name: values[fieldName][strategyIndex]?.name,
                                                //     answers: values?.observations?.[index]?.AssessmentGoalStrategyData[strategyIndex]?.answers,
                                                // });
                                                setFieldValue(`${outerFieldName}.${index}.AssessmentGoalStrategyData.${strategyIndex}.strategyRadio`, "newStrategy")
                                            }
                                            else {
                                                // alert("REACHED", fieldName)
                                                templatesOpen();
                                            }
                                        }}
                                    // onClick={() => strategyPush({
                                    //     answers: "",
                                    //     attachmentData: [],
                                    // })}
                                    >
                                        Continue
                                    </button>
                                    {
                                        touched.treatment_plans?.[index]?.AssessmentGoalStrategyData && !isEmpty(errors.treatment_plans?.[index]?.AssessmentGoalStrategyData) ? (
                                            <div className="text-danger mt-3">{"Please add strategy data"}</div>
                                        ) : null
                                    }
                                </div>
                            </div>
                    }
                </Col>

            </Row>
        </>
    )
}

export default QuestionTreatmentPlan;

